module.exports = __webpack_public_path__ + "static/img/album01_1.b524191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album01/album01_1.png
// module id = Q8WR
// module chunks = 1